import { Toaster } from "sonner";
import type { ReactNode } from "react";

import { Provider as QueryProvider } from "@/lib/tanstack-query/root-provider";
import { I18nProvider } from "@/locales/i18n-provider";
import { ThemeProvider } from "@/theme/theme-provider";
import { AuthProvider } from "@/lib/auth/auth-context";

export function AppProviders({ children }: { children: ReactNode }) {
	return (
		<QueryProvider>
			<I18nProvider>
				<ThemeProvider>
					<AuthProvider>
						{children}
						<Toaster position="top-right" richColors closeButton />
					</AuthProvider>
				</ThemeProvider>
			</I18nProvider>
		</QueryProvider>
	);
}
